import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Collapse, Row, Table } from 'reactstrap';
import CircleButton from "../../../../components/controls/buttons/CircleButton";
import SignatureInput from "../../../../components/controls/inputs/SignatureInput";
import PolyUtil from '../../../../util/PolyUtil';
import { handleRemoveRentalHistory, handleSaveSignature } from "../../actions/application";
import AddRentalHistoryForm from "./forms/AddRentalHistoryForm";
import EditRentalHistoryForm from "./forms/EditRentalHistoryForm";


class RentalHistoryFrame extends Component {
    state = {
        showAddHistory: false,
        editing: null
    };

    closeAddHistory = () => {
        this.setState({showAddHistory: false});
    };

    openAddHistory = () => {
        this.setState({showAddHistory: true});
    };

    saveSignature = (data) => {
        this.props._handleSaveSignature(data);
    };

    setEditing = (editing) => {
        this.setState({editing: this.state.editing === editing ? null : editing, showAddHistory: false});
    };

    render() {
        const showAddHistory = this.state.showAddHistory;
        const setEditing = this.setEditing;
        const {_handleRemoveRentalHistory, rental_history, is_rental_history_complete, is_authorization_given, tenant_name} = this.props;

        const hasHistory = is_rental_history_complete;

        const showAddForm = ((showAddHistory || !is_rental_history_complete) && !this.state.editing);

        return is_authorization_given ? (
            <div>
                <Row>
                    <h3>{!hasHistory ? <span>Time for a history lesson! Tell us about <em>all</em> of the places you've rented</span> : "This is your rental history (so far)"}</h3>
                </Row>
                <hr/>
                {
                    !hasHistory
                        ? <p>We'll start with your current residence and work our way backwards. If you're a student, on-campus housing is fine to list here (Hint: for Cal Poly, use 1 Grand Ave /
                            University Housing / 8057561226 / housing@calpoly.edu).</p>
                        : <div>
                            <p>It's pretty simple: the more rental history you have, the more a landlord will trust you because other landlords thought you were awesome enough to rent to in the past.</p>
                            <p>
                                If you were/are a student, include on-campus housing. For Cal Poly SLO, use the following details:<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>Address: </strong>1 Grand Avenue, San Luis Obispo, CA, USA (be sure to click the drop-down option)<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>Apt / Unit #: </strong>&lt;your dorm name/nuber, e.g. Sierra Madre, Tower 4, Room 3G&gt;<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>Landlord Name: </strong>University Housing<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>Landlord Phone: </strong>8057561226<br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>Landlord Email: </strong>housing@calpoly.edu
                            </p>
                        </div>
                }
                {
                    hasHistory && (
                        <span>
                            <Table hover responsive>
                                <thead>
                                <tr>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>Lease Start</th>
                                    <th>Lease End</th>
                                    <th>Landlord</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    rental_history.map(function (item, i) {
                                        const current = moment(item.lease_end).isAfter(moment());
                                        let start = moment(item.lease_start);
                                        start = start.format("MMMM") + ', ' + start.format("YYYY");
                                        let end = moment(item.lease_end);
                                        end = end.format("MMMM") + ', ' + end.format("YYYY");
                                        return (
                                            <tr key={i}>
                                                <th scope="row">{PolyUtil.getPropertyStreetAddress(item)}</th>
                                                <td>{PolyUtil.getPropertyCity(item)}</td>
                                                <td>{start}</td>
                                                <td>{current ? 'Current' : end}</td>
                                                <td>{item.reference && item.reference.name}</td>
                                                <td>
                                                    <CircleButton type="button"
                                                                  style={{margin: '0'}}
                                                                  color="info"
                                                                  onClick={() => setEditing(item.id)}
                                                                  outline>
                                                        <i className="fa fa-pencil"></i>
                                                    </CircleButton>
                                                </td>
                                                <td>
                                                    {
                                                        rental_history.length > 1 && (
                                                            <CircleButton type="button"
                                                                          style={{margin: '0'}}
                                                                          color="danger"
                                                                          onClick={() => _handleRemoveRentalHistory(item.id)}
                                                                          outline>
                                                                <i className="fa fa-minus"></i>
                                                            </CircleButton>
                                                        )
                                                    }

                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>

                            </Table>
                            {
                                (!showAddHistory && is_rental_history_complete) && !this.state.editing && (
                                    <div className="center">
                                        <CircleButton color="success" size="lg" onClick={this.openAddHistory} outline><i className="fa fa-plus"></i></CircleButton>
                                    </div>
                                )
                            }
                        </span>
                    )
                }

                {
                    showAddForm && (
                        <Collapse isOpen={showAddForm} style={{marginTop: '2em'}}>
                            {
                                <AddRentalHistoryForm onAdd={this.closeAddHistory}/>
                            }
                        </Collapse>
                    )
                }


                <Collapse isOpen={!!this.state.editing} style={{marginTop: '2em'}}>
                    {
                        !!this.state.editing && <EditRentalHistoryForm onAdd={() => this.setEditing(null)} editing={this.state.editing}/>
                    }
                </Collapse>

            </div>
        ) : (
            <div className="d-flex justify-content-center flex-column">
                <Row className="text-left">
                    <Col>
                        <h3>One thing before we get started...</h3>
                        <p>
                            <br />
                            In order to paint as clear a picture of you as possible, we ask your previous landlords for a reference from when you were their tenant. Many landlords require
                            a signature to release this information, so we're collecting it from you now to show to them later. Don't let the wall of text scare you; it's pretty standard stuff.
                            <br /><br />
                            By signing below, you (in layman's terms):<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&bull; are authorizing the landlords of your previous tenancies to provide us with rental references<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&bull; are acknowledging the fact that those references will be stored on our servers, shared with potential landlords, and will probably be used to evaluate your rental application<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&bull; are agreeing to indemnify us and your previous landlords in case those references don't paint the best picture of you and maybe cause your potential landlords to drop you as an applicant<br />
                            <br />
                            Yeah. You'd be surprised what people try to sue for 🙄
                        </p>
                        <hr />
                        <p>
                            <br />
                            I, {tenant_name}, authorize PolyRents, Inc. to collect rental references on my behalf.
                            <br /><br />
                            I give permission to my current and former property owners, landlords, property managers, or their affiliates to release any information about my rental history to PolyRents, Inc., who may,
                            in turn, store and share this information with owners, landlords, property managers, or their affiliates of properties to which I apply using PolyRents.
                            <br /><br />
                            I understand that the information provided will be used for the purpose of evaluating my application for rental housing.
                            <br /><br />
                            Moreover, I shall fully indemnify, hold harmless, and defend PolyRents, Inc., as well as my current and former property owners, landlords, property managers, or their affiliates, from and against
                            all claims, demands, actions, suits, damages, liabilities, losses, settlements, judgments, costs and expenses (including but not limited to reasonable attorney’s fees and costs), whether or not
                            involving a third party claim, which arise out of or relate to the rental reference information provided to PolyRents, Inc. by said current and former property owners, landlords, property managers, or their affiliates.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={8}>
                        <SignatureInput onSave={this.saveSignature}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tenant_name: (state.tenant.application.first_name + " " + state.tenant.application.last_name),
        rental_history: state.tenant.application.rental_history_rentals,
        is_rental_history_complete: state.tenant.application.is_rental_history_complete,
        is_authorization_given: state.tenant.application.reference_collection_authorized,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        _handleRemoveRentalHistory(id) {
            return dispatch(handleRemoveRentalHistory(id));
        },
        _handleSaveSignature(dataUrl) {
            return dispatch(handleSaveSignature(dataUrl));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentalHistoryFrame);



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/RentalHistoryFrame.js